<template>
<div class="CardContainer" :style="`max-width: ${maxWidth}; max-height: ${maxHeight};`">
  <span v-if="isActive" class="cart-count clickable">
    <v-icon color="white" @click="clearActive"> close </v-icon>
  </span>

  <div class="RewardsCard clickable" :class="cssClass" @click="onClick()">
    <v-layout row wrap class="text-xs-left" style="margin-bottom: 10px;">
      <v-flex v-if="showImage" xs3>
        <v-img :src="image" @error="onImageError" />
      </v-flex>

      <v-flex :xs9="showImage" :xs12="!showImage" style="padding-left: 10px;" class="textBody">
        <slot name="textBody">
        </slot>
      </v-flex>
    </v-layout>

    <slot name="description">
    </slot>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from 'lodash'

export default {
  props: {
    clearActive: {
      type: Function,
      default: () => false
    },
    onClick: {
      type: Function,
      default: () => false
    },

    image: {
      type: String,
      default: null
    },


    isActive: {
      type: Boolean,
      default: false
    },

    allowConfig: {
      type: Boolean,
      default: false
    },

    showItems: {
      type: Boolean,
      default: false
    },

    immutable: {
      type: Boolean,
      default: false
    },

    maxWidth: {
      type: String,
      default: '350px'
    },

    maxHeight: {
      type: String,
      default: '240px'
    },

    cssClass: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      error: false
    }
  },
  computed: {
    showImage() {
      return !!this.image && !this.error
    },

    ...mapGetters([ 'getStore' ])
  },

  methods: {
    getImage(item) {
      const url = get(item, 'imageURL', null) || get(this.getStore, 'images.REWARD[0].url', null)

      if (url)
        return `${process.env.VUE_APP_API_IMAGE}${url}`
    },
    onImageError() {
      this.error = true
    }
  }
}
</script>

<style scoped>
  .CardContainer {
    width: 100%;
    min-width: 200px;
    height: 100%;
    position: relative;
    display: inline-block;
    padding: 0 10px
  }
  .disabled {
    background-color: rgba(0,0,0,.12)!important;
  }

  .cart-count {
    display: inline-block;
    text-align: center;
    font-weight: bold;
    width: 32px;
    height: 32px;
    padding: 5px;
    background: var(--v-primary-base) !important;
    color: white;
    position: absolute;
    top: 0px;
    right: 10px;
    z-index: 1;
    box-sizing: border-box;
  }
  .cart-count ~ div .textBody {
    padding-right: 22px !important;
  }

  .v-image {
    border-radius: 5px;
  }
</style>
<style>
  .RewardsCard {
    text-align: left;
    padding: 10px 10px 10px;
    margin: 0px 0px 0px 0px;

    border-color: var(--v-primary-base) !important;
    border: solid;
    border-width: 2px 2px 2px 10px;
    border-radius: 5px;

    display: inline-block;

    width: 100%;
    min-width: 200px;

    height: 100%;

    white-space:normal;
    overflow: hidden;
  }

  .RewardsCard .header {
      font-size: 16px;
      font-weight: 600;
      color: #4caf50;

      -webkit-box-orient: vertical;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
  }
  .RewardsCard .subheader {
      font-size: 14px;
      font-weight: 400;
      color: grey;

      -webkit-box-orient: vertical !important;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;

      margin-top: 10px
  }
</style>
